import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {
   AbstractControl,
   FormGroup,
   UntypedFormArray,
   UntypedFormControl,
   UntypedFormGroup,
   Validators
} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {DialogService} from "../dialog/dialog.service";
import {Cliente, ClienteFactory} from "../../../models/Cliente";
import moment from "moment/moment";
import {ServerService} from "../../../services/server.service";
import _ from "lodash";
import {MatSelectChange} from "@angular/material/select";
import {HeaderComponentLink, HeaderTopComponent} from "../../standalone/header-top/header-top.component";
import {Interesse, InteresseFactory} from "../../../models/Interesse";
import {DataService} from "../../../services/data.service";
import {IndirizzoService} from "../../../services/indirizzo.service";
import {MatRadioChange} from "@angular/material/radio";

@Component({
   selector: 'app-cliente-form',
   templateUrl: './cliente-form.component.html',
   styleUrls: ['./cliente-form.component.scss']
})
export class ClienteFormComponent implements OnInit {
   @ViewChild("headerTop") headerTop!: HeaderTopComponent;

   @Input() is_vendor:boolean = false;
   @Input() isNew:boolean = false;
   @Input() isModal:boolean = false;
   @Input() isVendita:boolean = false;
   @Input() vendorSlug

   @Output() formComplete = new EventEmitter<any>();
   public selectedOption;

   public Cliente = Cliente;
   public clienteId;
   public clienteIdParam;
   public emailCliente;
   public vendorCliente;
   public listini:any[] = []
   public listiniGrouped:any = [];
   public listiniCliente:any = [];
   public interessi: Interesse[] = []
   private listiniData: any[] = []

   public cliente:Cliente = new Cliente({})
   public clienteFrm:UntypedFormGroup = new UntypedFormGroup({})
   public listinoSelFrm:UntypedFormGroup = new UntypedFormGroup({
      list_sel:new UntypedFormArray([])
   })

   selectedIndex = 0;
   links: HeaderComponentLink[] = [
      // {text: 'Dati clienti', index: 0, active: this.selectedIndex == 0}
   ];

   constructor(private route: ActivatedRoute,
               private serverSrv: ServerService,
               private dialog: DialogService,
               private clienteFctr: ClienteFactory,
               private interesseFctr: InteresseFactory,
               private router: Router,
               private dataSrv: DataService,
               public indirizzoSrv: IndirizzoService
   ) {
      this.clienteId = this.route.snapshot.paramMap.get('cliente_id')

      if (!this.vendorSlug){
         this.route.pathFromRoot[3].params.subscribe(res => {
            this.vendorSlug = res.esercizio_slug
         })
      }

      this.isNew = this.route.snapshot.data['isNew'];
      this.initClienteFrm()

      if(this.vendorSlug && !this.isNew){
         this.links.push(
            // {text: 'Assegna listini', index: 1, active: this.selectedIndex == 1}
         )
      }
   }

   ngOnInit(): void {

      this.indirizzoSrv.fetchStati()
      this.indirizzoSrv.frm = this.clienteFrm
      this.indirizzoSrv.model = this.cliente

      if (this.is_vendor){
         this.route.queryParamMap.subscribe(params => {
            this.clienteIdParam = params.get('cliente_id')
            this.emailCliente = params.get('email')
            this.vendorCliente = params.get('vendorcliente')
         })
      }
      if (this.emailCliente){
         this.clienteFrm.patchValue({email:this.emailCliente})
      }
      if (this.clienteIdParam) this.clienteId = this.clienteIdParam
      if (this.clienteId) {
         this.is_vendor ? this.getVendorCliente() : this.getCliente()
         this.indirizzoSrv.is_init = true

      }
   }

   async ngAfterViewInit() {
      if (this.clienteId){
         await this.fetchListiniCliente()
      }else this.fetchPvenditaListini()

      if (!this.isVendita && this.headerTop){
         this.headerTop.onLinkClick.subscribe(item=>{
            if(item.index != null) this.selectedIndex = item.index
         })
      }
   }

   fetchListiniCliente(){
      console.log("fetchListiniCliente")
      if(this.cliente) {
         let url = this.vendorSlug ? `/api/esercizi/${this.vendorSlug}/clienti/${this.clienteId}/listini` : `/api/esercizi/${this.cliente.data.esercizio?.slug}/clienti/${this.clienteId}/listini`
         this.serverSrv.getAll(null, url, {}).then(res => {
            this.listiniCliente = res
            console.log(this.listiniCliente)
            this.fetchPvenditaListini()
         }).catch(err => {
            console.error(err)
         })
      }
   }

   fetchInteressi(){
      this.interesseFctr.getInteressi(this.vendorSlug).then(res => {
         this.interessi = res
         // if (this.clienteId) this.fetchInteressiCliente()
         console.log(this.interessi)
      }).catch(err => {
         console.error(err)
      })
   }

   get listclienteFrm() : UntypedFormArray {
      return this.listinoSelFrm.controls['list_sel'] as UntypedFormArray
   }

   fetchPvenditaListini(){
      this.serverSrv.getAll(null, `/api/esercizi/${this.vendorSlug}/listini?tipo=cli&tab=promozioni`, {}).then(res =>{
         this.listini = res
         var that = this;
         this.listiniGrouped = _(this.listini)
            .groupBy('pvendita.id')
            .map( (items, id) => {
               return {
                  pvendita: id,
                  listino_cliente:items.find(elm1 => {
                     return _.find(that.listiniCliente,(elm2) => elm2.listino.id === elm1.id)
                  }),
                  pvendita_nome: items[0].pvendita.nome,
                  listini: _.map(items, listino => {
                     return {
                        nome:listino.nome,
                        id: listino.id
                     }
                  })
               };
            }).value();
         for (const i in this.listiniGrouped) {
            if (this.listiniGrouped[i]?.listino_cliente?.id) this.listclienteFrm.push(new UntypedFormControl(this.listiniGrouped[i].listino_cliente.id));
            else this.listclienteFrm.push(new UntypedFormControl(null));
         }
      }).catch(err => {
         console.error(err)
      })
   }

   getCliente(){
      this.clienteFctr.getCliente(this.clienteId ,this.vendorSlug).then((cliente) => {
         this.cliente = cliente
         this.indirizzoSrv.model = this.cliente
         console.log(this.indirizzoSrv.model)
         this.vendorSlug = this.cliente.data.esercizio?.slug
         this.patchClienteFrm()
      }).catch(err => {
         console.error(err)
      })
   }

   getVendorCliente(){
      this.clienteFctr.getVendorCliente(this.vendorSlug, this.clienteId).then(res => {
         this.cliente = res
         console.log(this.cliente)
         this.indirizzoSrv.model = this.cliente
         console.log(this.indirizzoSrv.model)
         this.patchClienteFrm()
      }).catch(err => {
         console.error(err)
      })
   }

   initClienteFrm(){
      this.clienteFrm =  new UntypedFormGroup({
         nome: new UntypedFormControl(null, Validators.required),
         cognome: new UntypedFormControl(null, Validators.required),
         cellulare_prefix: new UntypedFormControl("+39"),
         telefono: new UntypedFormControl(null),
         interessi: new UntypedFormControl([]),
         email: new UntypedFormControl('', [Validators.required, Validators.email]),
         conferma_email: new UntypedFormControl('', [Validators.required, Validators.email]),
         data_nascita: new UntypedFormControl(null),
         note_vendor: new UntypedFormControl(null),
         sesso: new UntypedFormControl(null),
         tipo: new UntypedFormControl('PF', Validators.required),
         ragione_sociale: new UntypedFormControl(null),
         pivacf: new UntypedFormControl(null),
         pec: new UntypedFormControl(null, Validators.email),
         esercizio: new UntypedFormControl(null),
         note: new UntypedFormControl(null),
         n_rea: new UntypedFormControl(null),
         cod_sdi: new UntypedFormControl(null),

         indirizzo: new FormGroup({
            stato: new UntypedFormControl(null),
            regione: new UntypedFormControl({value:null, disabled:true}),
            provincia: new UntypedFormControl({value:null, disabled:true}),
            citta: new UntypedFormControl({value:null, disabled:true}),
            indirizzo: new UntypedFormControl(null),
            civico: new UntypedFormControl(null),
            cap: new UntypedFormControl(null),
         }),
      }, { validators: this.clienteId ? null : this.emailMatchingValidatior });

      if (this.clienteId){
         this.clienteFrm.get('conferma_email')?.setValidators(null)
         this.clienteFrm.get('conferma_email')?.disable()
         this.clienteFrm.updateValueAndValidity();
      }
   }

    patchClienteFrm(){
      this.clienteFrm.patchValue(this.cliente.data)
      this.clienteFrm.get('esercizio')?.patchValue(this.cliente.data.esercizio?.id)
      setTimeout(() => {
         this.indirizzoSrv.patchValueIndirizzo()
      }, 300)
   }

   clickSalvaCliente() {
      let valid = this.checkValidForm()
      if (valid){
         console.log(this.clienteFrm.value)

         let v = this.clienteFrm.value
         if(v.data_nascita){
            v.data_nascita = moment(v.data_nascita).format("YYYY-MM-DD")
         }

         if (!this.clienteId){
            this.clienteFctr.postCliente(v).then(async res => {
               this.dialog.showToastSuccess({title:"Operazione completata", msg:"Cliente aggiunto"})
               // await this.router.navigate(["/admin/clienti"])
            }).catch(err => {
               this.dialog.showError({title:"Attenzione!", err:err})
            })
         } else {
            this.clienteFctr.putCliente(this.clienteId, v).then(async res => {
               this.dialog.showToastSuccess({title:"Operazione completata", msg:"Cliente salvato"})

            }).catch(err => {
               this.dialog.showError({title:"Attenzione!", err:err})
            })
         }
      }
   }

   clickSalvaVendorCliente() {
      let valid = this.checkValidForm()
      console.log(this.clienteFrm.getRawValue())
      if (valid){
         this.clienteFrm.value.data_nascita = moment(this.clienteFrm.value.data_nascita).format("YYYY-MM-DD")
         if (this.isNew){
            this.clienteFctr.postCliente({dati_cliente:this.clienteFrm.value, listini_cliente:this.listiniGrouped}, this.vendorSlug).then(async res => {
               this.dialog.showSuccess({title:"Operazione completata", msg:"Cliente aggiunto"})
               if (!this.isModal && !this.isVendita)
                  await this.router.navigate([`../`], {relativeTo:this.route})
               else this.formComplete.emit(res);
            }).catch(err => {
               this.dialog.showError({title:"Attenzione!", err:err})
            })
         }else {
            this.clienteFctr.putCliente(this.clienteId, this.clienteFrm.value, this.vendorSlug).then(async res => {
               this.dialog.showSuccess({title:"Operazione completata", msg:"Cliente salvato"})
               await this.router.navigate([`../`], {relativeTo:this.route})
            }).catch(err => {
               this.dialog.showError({title:"Attenzione!", err:err})
            })
         }
      }
   }

   checkValidForm(){
      console.log(this.clienteFrm)

      if (this.clienteFrm.invalid){
         // this.dialog.showError({title:"Attenzione!", err:"Devi compilare i campi obbligatori per salvare il cliente"})
         this.clienteFrm.markAllAsTouched()
         return false
      }else return true
   }

   setListinoCliente(e: MatSelectChange, pvendita: any, i) {
      if (this.clienteId){

         let lstFrmGroup = this.listinoSelFrm.controls
         let lstFrmArray = lstFrmGroup['list_sel'] as UntypedFormArray

         this.dialog.showConfirm({title:"Assegna listino", msg:"Vuoi assegnare il listino al cliente?"}).then(() => {
            let data = {
               listino:e.value,
               pvendita:pvendita,
               cliente:this.clienteId
            }
            this.serverSrv.post(`/api/esercizi/${this.vendorSlug}/clienti/${this.clienteId}/listini`, data, null).then(res => {
               console.log(res)
               this.dialog.showToastSuccess({title:"Assegna listino", msg:"Listino assegnato"})
            }).catch(err => {
               console.error(err)
               lstFrmArray.controls[i]?.patchValue(null)
            })
         }).catch(err => {
            console.log(err)
            lstFrmArray.controls[i]?.patchValue(null)
         })
      }else {
         this.listiniGrouped[i].listino_cliente = e.value
      }
   }

   fetchInteressiCliente() {
      this.serverSrv.getAll(null, `/api/esercizi/${this.vendorSlug}/clienti/${this.clienteId}/interessi`, {}).then(res =>{
         if (res.length > 0) this.clienteFrm.get('interessi')?.patchValue(res)
         console.log(this.clienteFrm.value)
         console.log(res)
      }).catch(err => {
         console.error(err)
      })
   }

   clickDissociaListinoCliente(pvendita: any, i) {
      this.dialog.showConfirm({title:"Dissocia listino", msg:"Vuoi davvero dissociare il listino?"}).then(() => {
         let lstFrmGroup = this.listinoSelFrm.controls
         let lstFrmArray = lstFrmGroup['list_sel'] as UntypedFormArray
         let listino_id = lstFrmArray.controls[i].value
         this.serverSrv.delete(`/api/esercizi/${this.vendorSlug}/clienti/${this.clienteId}/listini/${listino_id}`, {}, null).then(res => {
            console.log(res)
            lstFrmArray.controls[i]?.patchValue(null)
            this.dialog.showToastSuccess({title:"Dissocia listino", msg:"Listino dissociato"})
         }).catch(err => {
            console.log(err)
            this.dialog.showError({title:"Attenzione!", err:err})
         })
      })
   }

   emailMatchingValidatior(control: AbstractControl) {
      let email = control.get('email');
      let confirmation = control.get('conferma_email');
      let has_err = email && confirmation && email.value !== confirmation.value ? { not_same_email: true } : null;
      if (has_err) confirmation?.setErrors({not_same_pswd: true});
      else confirmation?.setErrors(null);
      return has_err;
   }

   onChangeTipo($event: MatRadioChange) {
      // $event.value == Cliente.TipoChoices.Azienda ? this.clienteFrm.get('indirizzo')?.enable() : this.clienteFrm.get('indirizzo')?.disable()
   }
}
